import React from 'react';
import PropTypes from 'prop-types';

import {Step1} from './Step1';
import {Step2} from './Step2';
import {Step3} from './Step3';
import {Step4} from './Step4';

import { PROGRESS } from '../../constants/ProgressStates';

const progressSteps = {
    1: Step1,
    2: Step2,
    3: Step3,
    4: Step4
};

const AllSteps = props => {
    const {
        isRelease,
        offlinePayment,
        onButtonClick,
        step,
        isCash
    } = props;

    // initialize expanded steps as incomplete
    let steps = [
        <Step1 isCash={isCash} expanded />,
        <Step2 expanded status={PROGRESS.INCOMPLETE} offlinePayment={offlinePayment} />,
        <Step3 isCash={isCash} expanded status={PROGRESS.INCOMPLETE} offlinePayment={offlinePayment} />,
        <Step4 expanded status={PROGRESS.INCOMPLETE} offlinePayment={offlinePayment} />
    ];

    if (!isCash) {
        steps = [
            <Step1 isCash={isCash} expanded />,
            <Step2 expanded status={PROGRESS.INCOMPLETE} offlinePayment={offlinePayment} />,
            <Step3 isCash={isCash} expanded status={PROGRESS.INCOMPLETE} offlinePayment={offlinePayment} />
        ];
    }

    for (let i = 1; i < step; i++) {
        switch (i) {
            case 1:
                steps[0] = (
                    <Step1
                        expanded
                        isCash={isCash}
                        status={PROGRESS.COMPLETE}
                        isRelease={isRelease}
                        onButtonClick={onButtonClick}
                    />
                );
                break;
            case 2:
                steps[1] = <Step2 expanded status={PROGRESS.COMPLETE} />;
                break;
            case 3:
                steps[2] = <Step3 isCash={isCash} expanded status={PROGRESS.COMPLETE} offlinePayment={offlinePayment} />;
                break;
            case 4:
                steps[3] = <Step4 expanded status={PROGRESS.COMPLETE} offlinePayment={offlinePayment} />;
                break;
            default:
                break;
        }
    }

    // Step1 component requires some extra props
    const stepProps = step === 1 && isRelease ? {isRelease} : {offlinePayment};

    const ActiveStep = progressSteps[step];
    steps[step - 1] = (
        <ActiveStep
            isCash={isCash}
            status={PROGRESS.ACTIVE}
            {...stepProps} />
    );

    return steps;
};

AllSteps.displayName = 'AllSteps';

AllSteps.propTypes = {
    isRelease: PropTypes.bool,
    offlinePayment: PropTypes.bool,
    onButtonClick: PropTypes.func,
    step: PropTypes.number,
    isCash: PropTypes.bool
};

export default AllSteps;
